export const CSS_CLASSES = {
  OVERLAY: 'chatbot-overlay',
  POPUP: 'chatbot-popup',
  HEADER: 'chatbot-header',
  TITLE: 'chatbot-title',
  AVATAR: 'chatbot-avatar',
  INFO: 'chatbot-info',
  ACTIONS: 'header-actions',
  LOGIN_BAR: 'chatbot-login-bar',
  LOGIN_CONTENT: 'login-bar-content',
  LOGIN_MESSAGE: 'login-message',
  LOGIN_ICON: 'login-icon',
  LOGIN_TEXT: 'login-text',
  LOGIN_BUTTON: 'login-button',
  INITIAL_MESSAGE: 'initial-message',
  MESSAGES: 'chatbot-messages',
  MESSAGE: 'message',
  MESSAGE_CONTENT: 'message-content',
  MESSAGE_TEXT: 'message-text',
  MESSAGE_TIME: 'message-time',
  LOADING_SPINNER: 'loading-spinner',
  SPINNER: 'spinner',
  OPTIONS: 'chatbot-options',
  OPTIONS_TITLE: 'chatbot-options-title',
  WORKSPACE_OPTION_BTN: 'workspace-option-btn',
  WORKSPACE_OPTION_BTN_YES: 'workspace-option-btn-yes',
  WORKSPACE_OPTION_BTN_NO: 'workspace-option-btn-no',
  LOCATION_DROPDOWN: 'location-dropdown',
  SPACE_SUGGESTION_OPTION: 'space-suggestion-option',
  SPACE_OPTION_CONTENT: 'space-option-content',
  SPACE_IMAGE: 'space-image',
  SPACE_PLACEHOLDER: 'space-placeholder',
  SPACE_DETAILS: 'space-details',
  SPACE_NAME: 'space-name-chatBot',
  SPACE_PRICE: 'space-price',
  SELECTED_INDICATOR: 'selected-indicator',
  CONTACT_AGENT_OPTION: 'contact-agent-option',
  FIND_SOMETHING_ELSE_OPTION: 'find-something-else-option',
  CONTACT_FORM: 'chatbot-contact-form',
  FORM_GROUP: 'form-group',
  FORM_LABEL: 'form-label',
  FORM_ERROR: 'form-error',
  FORM_ACTIONS: 'form-actions',
  OPTIONAL_TEXT: 'optional-text',
  FIELD_HELPER_TEXT: 'field-helper-text',
  AGENT_CONTACT_DETAILS: 'agent-contact-details',
  AGENT_CONTACT_MESSAGE: 'agent-contact-message',
  AGENT_PHONE_NUMBER: 'agent-phone-number',
  PHONE_ICON: 'phone-icon',
  PHONE_LINK: 'phone-link',
  INPUT: 'chatbot-input',
  DISCLAIMER: 'chatbot-disclaimer',
  DISCLAIMER_CONTENT: 'disclaimer-content',
  DISCLAIMER_TEXT: 'disclaimer-text',
  INFO_BUTTON: 'info-button',
  INFO_MODAL: 'info-modal',
  INFO_CONTENT: 'info-content',
  INFO_HEADER: 'info-header',
  INFO_BODY: 'info-body',
  CLOSE_ICON: 'close-icon',
  CLOSE_INFO: 'close-info',
  CLOSING: 'closing',
  SELECTED: 'selected',
  ERROR: 'error',
  AVAILABLE_SPACES_CARD: 'available-spaces-card',
  AVAILABLE_SPACES_NAME: 'available-spaces-name',
  AVAILABLE_SPACES_LOCATION: 'available-spaces-location',
  AVAILABLE_SPACES_PRICE: 'available-spaces-price',
  WORKSPACE_OPTIONS_GRID: 'workspace-options-grid',
  WORKSPACE_OPTION_PILL: 'workspace-option-pill',
  SPACE_SUGGESTION_OPTION: 'space-suggestion-option',
  SPACE_OPTION_CONTENT: 'space-option-content',
  SPACE_IMAGE: 'space-image',
  SPACE_PLACEHOLDER: 'space-placeholder',
  SPACE_DETAILS: 'space-details',
  SPACE_NAME: 'space-name-chatBot',
  SPACE_PRICE: 'space-price',
  SELECTED_INDICATOR: 'selected-indicator',
  ORGANIZED_WORKSPACE_OPTION: 'organized-workspace-option',
  WORKSPACE_OPTION_HEADER: 'workspace-option-header',
  WORKSPACE_NAME: 'workspace-name',
  WORKSPACE_CATEGORY: 'workspace-category',
  WORKSPACE_DESCRIPTION: 'workspace-description',
  WORKSPACE_DETAILS: 'workspace-details',
  WORKSPACE_RATE: 'workspace-rate',
  SELECT_WORKSPACE_BTN: 'select-workspace-btn',
};

// Button Types
export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
};

// Button Variants
export const BUTTON_VARIANTS = {
  RELOAD: 'reload-button',
  CLOSE: 'close-button',
  LOGIN: 'login-button',
  SUBMIT: 'submit-button',
  CANCEL: 'cancel-button',
  WORKSPACE_OPTION: 'workspace-option-btn',
  CONTACT_AGENT: 'contact-agent-option',
  FIND_SOMETHING_ELSE: 'find-something-else-option',
  INFO: 'info-button',
  CLOSE_ICON: 'close-icon',
  CLOSE_INFO: 'close-info',
};

// Icon Sizes
export const ICON_SIZES = {
  SMALL: 16,
  MEDIUM: 18,
  LARGE: 24,
};

// Avatar Dimensions
export const AVATAR_DIMENSIONS = {
  WIDTH: 32,
  HEIGHT: 32,
};

// Space Image Dimensions
export const SPACE_IMAGE_DIMENSIONS = {
  WIDTH: '60px',
  HEIGHT: '75px',
  MAX_WIDTH: '60px',
  MAX_HEIGHT: '70px',
  MIN_WIDTH: '60px',
  MIN_HEIGHT: '75px',
};

// Form Input Types
export const INPUT_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  TEL: 'tel',
  TEXTAREA: 'textarea',
  SUBMIT: 'submit',
  BUTTON: 'button',
};

// Form Field Names
export const FORM_FIELD_NAMES = {
  NAME: 'name',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  MESSAGE: 'message',
};

// Form Validation States
export const FORM_VALIDATION_STATES = {
  VALID: 'valid',
  INVALID: 'invalid',
  PRISTINE: 'pristine',
  DIRTY: 'dirty',
};

// Loading States
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Animation Durations
export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
};

// Z-Index Values
export const Z_INDEX = {
  OVERLAY: 1000,
  POPUP: 1001,
  MODAL: 1002,
  TOOLTIP: 1003,
};

// Spacing Values
export const SPACING = {
  XS: '4px',
  SM: '8px',
  MD: '16px',
  LG: '24px',
  XL: '32px',
};

// Border Radius
export const BORDER_RADIUS = {
  SMALL: '4px',
  MEDIUM: '8px',
  LARGE: '12px',
  ROUND: '50%',
};

// Box Shadows
export const BOX_SHADOWS = {
  LIGHT: '0 2px 4px rgba(0, 0, 0, 0.1)',
  MEDIUM: '0 4px 8px rgba(0, 0, 0, 0.15)',
  HEAVY: '0 8px 16px rgba(0, 0, 0, 0.2)',
};

// Colors
export const COLORS = {
  PRIMARY: '#ff0000ff',
  SECONDARY: '#6c757d',
  SUCCESS: '#28a745',
  DANGER: '#dc3545',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY: {
    100: '#f8f9fa',
    200: '#e9ecef',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#495057',
    800: '#343a40',
    900: '#212529',
  },
};

// Typography
export const TYPOGRAPHY = {
  FONT_FAMILY: {
    PRIMARY: 'Arial, sans-serif',
    SECONDARY: 'Georgia, serif',
    MONOSPACE: 'Courier New, monospace',
  },
  FONT_SIZE: {
    XS: '12px',
    SM: '14px',
    MD: '16px',
    LG: '18px',
    XL: '20px',
    XXL: '24px',
  },
  FONT_WEIGHT: {
    LIGHT: 300,
    NORMAL: 400,
    MEDIUM: 500,
    SEMI_BOLD: 600,
    BOLD: 700,
  },
  LINE_HEIGHT: {
    TIGHT: 1.2,
    NORMAL: 1.5,
    RELAXED: 1.8,
  },
};

// Breakpoints
export const BREAKPOINTS = {
  XS: '480px',
  SM: '768px',
  MD: '992px',
  LG: '1200px',
  XL: '1400px',
};

// Transitions
export const TRANSITIONS = {
  FAST: 'all 0.15s ease-in-out',
  NORMAL: 'all 0.3s ease-in-out',
  SLOW: 'all 0.5s ease-in-out',
};

// Cursor Types
export const CURSOR_TYPES = {
  DEFAULT: 'default',
  POINTER: 'pointer',
  TEXT: 'text',
  NOT_ALLOWED: 'not-allowed',
  WAIT: 'wait',
};

// Overflow Types
export const OVERFLOW_TYPES = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
  SCROLL: 'scroll',
  AUTO: 'auto',
};

// Display Types
export const DISPLAY_TYPES = {
  BLOCK: 'block',
  INLINE: 'inline',
  INLINE_BLOCK: 'inline-block',
  FLEX: 'flex',
  GRID: 'grid',
  NONE: 'none',
};

// Position Types
export const POSITION_TYPES = {
  STATIC: 'static',
  RELATIVE: 'relative',
  ABSOLUTE: 'absolute',
  FIXED: 'fixed',
  STICKY: 'sticky',
};
